/**
 * Faven Landing Page JavaScript
 * Handles all interactive functionality for the Faven landing page
 */

// Alpine.js Global App Data
document.addEventListener('alpine:init', () => {
  Alpine.store('favenApp', {
    // Global state
    mobileMenuOpen: false,
    showFloatingCTA: false,
    
    // Notification system
    notification: {
      show: false,
      message: '',
      type: 'success'
    },
    
    // Initialize app
    init() {
      this.initFloatingCTA();
      this.initAnimations();
      this.enhanceSliders();
    },
    
    
    // Mobile menu methods
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },
    
    closeMobileMenu() {
      this.mobileMenuOpen = false;
    },
    
    // Floating CTA functionality
    initFloatingCTA() {
      let heroSection = document.getElementById('hero');
      if (!heroSection) return;
      
      window.addEventListener('scroll', () => {
        const heroBottom = heroSection.offsetTop + heroSection.offsetHeight;
        const scrollY = window.scrollY;
        const leadForm = document.getElementById('lead-form');
        
        // Show floating CTA when scrolled past hero but before lead form
        if (scrollY > heroBottom && leadForm && scrollY < leadForm.offsetTop - 200) {
          this.showFloatingCTA = true;
        } else {
          this.showFloatingCTA = false;
        }
      });
    },
    
    // Notification system
    showNotification(message, type = 'success') {
      this.notification = {
        show: true,
        message: message,
        type: type
      };
      
      // Auto hide after 5 seconds
      setTimeout(() => {
        this.hideNotification();
      }, 5000);
    },
    
    hideNotification() {
      this.notification.show = false;
    },
    
    // Initialize scroll animations
    initAnimations() {
      const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      };
      
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
          }
        });
      }, observerOptions);
      
      // Observe elements for animation
      const animatedElements = document.querySelectorAll('.hover-scale, .bg-faven-gray');
      animatedElements.forEach(el => {
        el.style.opacity = '0';
        el.style.transform = 'translateY(30px)';
        el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
        observer.observe(el);
      });
    },
    
    // Enhance range sliders with dynamic backgrounds
    enhanceSliders() {
      const sliders = document.querySelectorAll('input[type="range"]');
      
      sliders.forEach(slider => {
        // Add dynamic class for JavaScript-controlled styling
        slider.classList.add('range-slider-dynamic');
        
        const updateSliderBackground = () => {
          const value = slider.value;
          const min = slider.min;
          const max = slider.max;
          const percentage = (value - min) / (max - min) * 100;
          
          slider.style.background = `linear-gradient(to right, #a8f63e 0%, #a8f63e ${percentage}%, #4a5568 ${percentage}%, #4a5568 100%)`;
        };
        
        updateSliderBackground();
        slider.addEventListener('input', updateSliderBackground);
      });
    },
    
    // Update slider backgrounds
    updateSliderBackgrounds() {
      const sliders = document.querySelectorAll('input[type="range"]');
      
      sliders.forEach(slider => {
        const value = slider.value;
        const min = slider.min;
        const max = slider.max;
        const percentage = (value - min) / (max - min) * 100;
        
        slider.style.background = `linear-gradient(to right, #a8f63e 0%, #a8f63e ${percentage}%, #4a5568 ${percentage}%, #4a5568 100%)`;
      });
    }
  });
});

// Initialize smooth scrolling immediately - don't wait for Alpine
(function() {
  'use strict';
  
  // Use capture phase to intercept clicks before other handlers
  document.addEventListener('click', function(e) {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;
    
    const href = link.getAttribute('href');
    if (!href || href === '#' || href.includes('icon-')) return;
    
    e.preventDefault();
    e.stopPropagation();
    
    const targetId = href.substring(1);
    const target = document.getElementById(targetId);
    
    if (target) {
      // Calculate positions
      const currentScroll = window.pageYOffset;
      const targetTop = target.getBoundingClientRect().top + window.pageYOffset;
      const targetPosition = targetTop - 80; // Account for header
      const scrollDistance = targetPosition - currentScroll;
      
      // Reasonable duration: 500ms base + 0.5ms per pixel, max 1200ms
      const duration = Math.min(500 + Math.abs(scrollDistance) * 0.5, 1200);
      
      let startTime = null;
      
      function scrollAnimation(currentTime) {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1);
        
        // Smooth easing
        const easeInOutQuad = progress < 0.5 
          ? 2 * progress * progress 
          : 1 - Math.pow(-2 * progress + 2, 2) / 2;
        
        const currentPosition = currentScroll + (scrollDistance * easeInOutQuad);
        window.scrollTo(0, currentPosition);
        
        if (progress < 1) {
          requestAnimationFrame(scrollAnimation);
        }
      }
      
      requestAnimationFrame(scrollAnimation);
    }
  }, true); // Use capture phase
})();

// Initialize app when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  if (typeof Alpine !== 'undefined' && Alpine.store) {
    // Ensure the favenApp store exists before calling init
    const favenStore = Alpine.store('favenApp');
    if (favenStore && typeof favenStore.init === 'function') {
      favenStore.init();
    }
  }
});

// Custom CSS for enhanced styling (minimal - most styles now in Tailwind)
const favenStyles = document.createElement('style');
favenStyles.textContent = `
  /* Dynamic range slider background updates - requires JavaScript */
  .range-slider-dynamic {
    -webkit-appearance: none;
    appearance: none;
    height: 8px;
    border-radius: 4px;
    outline: none;
    background: linear-gradient(to right, #a8f63e 0%, #a8f63e 30%, #4a5568 30%, #4a5568 100%);
  }
`;

document.head.appendChild(favenStyles);
